import { QueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { ApiError } from '@/lib/apiClient';

/**
 * Never retry a request the server has already judged: a 404 or a 403 will
 * return the same answer three times and only delays the error reaching the UI.
 */
function shouldRetry(failureCount, error) {
  if (error instanceof ApiError) {
    if (error.status === 0) return failureCount < 2; // network blip
    if (error.status >= 400 && error.status < 500) return false;
  }
  return failureCount < 2;
}

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        throwOnError: false,
      },
      mutations: {
        retry: false,
        // Mutations are user-initiated, so a failure always deserves a toast.
        // Queries stay silent and let the component render its own error state.
        onError: (error) => {
          const message =
            error instanceof ApiError ? error.message : 'Something went wrong. Please try again.';
          toast.error(message);
        },
      },
    },
  });
}

export const queryClient = createQueryClient();
